import React, { useState, useContext, useEffect } from "react";
import { Auth } from 'aws-amplify';

import { connect } from "react-redux";
import { useNavigate } from 'react-router-dom';

import { ProfielContext } from "../../../context/profiel-context";

import { Avatar, Badge, Tooltip, Button, Menu, MenuItem, ListItemIcon, ListItemText } from "@mui/material";
import Gravatar from 'react-gravatar';
import InputIcon from "@mui/icons-material/Input";
import PersonIcon from "@mui/icons-material/Person";
import ChatIcon from "@mui/icons-material/ChatBubble";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import theme from "../../../theme";
import { withTranslation } from "react-i18next";

const Profile = ({ t, ...props }) => {
  const navigate = useNavigate();

  const profielContext = useContext(ProfielContext);
  const [imageError, setImageError] = useState(false);

  const [name, setName] = useState(
    profielContext.profiel.naam ? profielContext.profiel.naam : ""
  );
  const [surname, setSurname] = useState(
    profielContext.profiel.van ? profielContext.profiel.van : ""
  );

  const [notificationsCount, setNotificationsCount] = useState(0);

  useEffect(() => {
    let counter = 0;
    for (const notification of props.notifications) {
      if (!notification.viewed) {
        counter++;
      }
    }
    setNotificationsCount(counter);
  }, [props.notifications]);

  useEffect(() => {
    setName(profielContext.profiel.naam ? profielContext.profiel.naam : "");
    setSurname(profielContext.profiel.van ? profielContext.profiel.van : "");
  }, [profielContext.profiel]);

  const tekenUit = () => {
    Auth.signOut()
      .then((data) => {
        localStorage.removeItem("profiel");
        localStorage.removeItem("boerderye");
        profielContext.logout();
      })
      .catch((err) => console.log(err));
  };

  const gaanNaProfiel = () => {
    navigate(`/profiel/${profielContext.profiel.gebruikernaam}`);
  };
  const gaanNaBoodskappe = () => {
    navigate(
      `/profiel/${profielContext.profiel.gebruikernaam}/boodskappe`
    );
  };

  const options = [
    {
      key: "profiel",
      text: t("Profiel"),
      icon: <PersonIcon className="menuPopupIcons" />,
      onClick: gaanNaProfiel,
    },
    {
      key: "boodskappe",
      text: t("Boodskappe"),
      icon: <ChatIcon className="menuPopupIcons" />,
      onClick: gaanNaBoodskappe,
    },
    {
      key: "tekenuit",
      text: t("Teken uit"),
      icon: <InputIcon className="menuPopupIcons" />,
      onClick: tekenUit,
    },
  ];

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Button
        onClick={handleOpen}
        endIcon={<KeyboardArrowDownIcon />}
      >
        <Tooltip
          title={notificationsCount === 1 ? t("eenboodskap", { value: notificationsCount }) : t("aantalboodskappe", { value: notificationsCount })}
          arrow
        >
          <Badge
            color="secondary"
            className="notificationsBadge"
            badgeContent={notificationsCount}
          >
            <Avatar sx={{ bgcolor: theme.palette.primary.main, color: theme.palette.primary.contrastText, fontWeight: 700 }} className="sidebarAvatar">
              {!imageError ? (
                  <Gravatar
                    email={profielContext.profiel.epos}
                    size={50}
                    onError={() => setImageError(true)}
                    default="404" // Important: triggers onError when no Gravatar
                    style={{ width: '100%', height: '100%', borderRadius: '50%' }}
                  />
              ) : (
                profielContext.profiel.naam.charAt(0)
              )}
            </Avatar>
          </Badge>
        </Tooltip>
        {name} {surname}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              left: 14,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: 'left', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
      >
        {options.map(item => <MenuItem
          key={item.key}
          onClick={item.onClick}
        >
          <ListItemIcon>
            {item.icon}
          </ListItemIcon>
          <ListItemText primary={item.text} />
        </MenuItem>)}
      </Menu>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    notifications: state.notifications.notifications,
  };
};

export default connect(mapStateToProps)(withTranslation(["translation"])(Profile));
